// extracted by mini-css-extract-plugin
export default {"optionsGroup":"favorit_optionsGroup__pv0id"};